import { store } from '../../../../app/store';
import { extractErrorMessage } from '../../../../utils/errorUtils';
import { gridApi } from '../../api/gridApi';
import type { CommandHandler } from '../types';

export const generateInvoicesCommandHandler: CommandHandler = async (_command, context) => {
  const parentId = Number(context.parentId ?? context.entityId);
  if (!Number.isInteger(parentId) || parentId <= 0) {
    return {
      success: false,
      error: 'Open a saved salary calculation first.',
    };
  }

  const selectedLineIds = Array.from(context.selectedRows ?? [])
    .map((rowId) => Number(rowId))
    .filter((rowId) => Number.isInteger(rowId) && rowId > 0);

  try {
    const message = await store
      .dispatch(
        gridApi.endpoints.generateInvoices.initiate({
          parentId,
          // Existing backend contract uses this name, although the values are salary line IDs.
          selectedEmployees: selectedLineIds,
        })
      )
      .unwrap();

    return { success: true, message };
  } catch (error) {
    return {
      success: false,
      error: extractErrorMessage(error, 'Failed to generate invoices.'),
    };
  }
};
